export const cardDirective = {
    inserted:function(el,binding,vnode){
        let field = null
        if(binding.modifiers['holder']) field = 'holder'
        else if(binding.modifiers['card-number']) field = 'card-number'
        else if(binding.modifiers['expire']) field = 'expire'
        else if(binding.modifiers['cvc']) field = 'cvc'
        else field = null

        el.addEventListener('focus',()=>{
            vnode.context.$refs.card.focus(field)
        })
        el.addEventListener('blur',()=>{
            vnode.context.$refs.card.focus(null)
        })
    }
}